/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit XIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function XIcon({
  children,
  viewPath = "/DesignSystem/Svgs/XIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 16,
  height = 16,
  fill = "none",
  stroke = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="XIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 16 16"
 style={{'--as-1-623OY': alignSelf,'--mt-2-623OY': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-623OY': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-623OY': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-623OY': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-623OY': opacity,'--w-7-623OY': typeof width === 'number' ? `${width}px` : width,'--h-8-623OY': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="XIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={2}
 strokeMiterlimit={10}
 d="M13.1 2.9L2.9 13.1M13.1 13.1L2.9 2.9"
 style={{'--f-9-623OY': fill,'--s-10-623OY': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}